"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomizeCoordinatesWithinGivenRadius = exports.getPublishedProjectsFeatureArrayFromProjectsDictionary = void 0;
const core_1 = require("@natomas-org/core");
const accessors_1 = require("../accessors");
const PublicProjectInfoAccessor_1 = require("../accessors/PublicProjectInfo/PublicProjectInfoAccessor");
const turf = require("@turf/turf");
// Returns a feature array given a dictionary of nearby projects. Randomizes the
//  returned coordinates within a 150 radius meters
const getPublishedProjectsFeatureArrayFromProjectsDictionary = (projectsDictionary) => {
    const featureArray = [];
    Object.values(projectsDictionary).forEach((projectDetails) => {
        if (!core_1.Address.getCoordinates(core_1.Address.dataToAddress(projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.project_address)) ||
            !(projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.published)) {
            return;
        }
        const latitude = core_1.Address.getLatitude(core_1.Address.dataToAddress(projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.project_address));
        const longitude = core_1.Address.getLongitude(core_1.Address.dataToAddress(projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.project_address));
        if (!latitude || !longitude) {
            return;
        }
        const randomizedCoordinates = accessors_1.PublicProjectInfo.getRandomizedCoordinates(projectDetails);
        let displayGeometry = undefined;
        if (!!randomizedCoordinates &&
            !!(randomizedCoordinates === null || randomizedCoordinates === void 0 ? void 0 : randomizedCoordinates.lat) &&
            !!(randomizedCoordinates === null || randomizedCoordinates === void 0 ? void 0 : randomizedCoordinates.lng)) {
            displayGeometry = {
                type: "Point",
                coordinates: [randomizedCoordinates === null || randomizedCoordinates === void 0 ? void 0 : randomizedCoordinates.lng, randomizedCoordinates === null || randomizedCoordinates === void 0 ? void 0 : randomizedCoordinates.lat],
            };
        }
        const alreadyExists = featureArray.find((feature) => {
            var _a, _b;
            return (0, core_1.shallowEquals)((_b = (_a = feature.properties) === null || _a === void 0 ? void 0 : _a.projectDetails) === null || _b === void 0 ? void 0 : _b.address, projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.project_address);
        });
        if (!alreadyExists || (alreadyExists === null || alreadyExists === void 0 ? void 0 : alreadyExists.length) < 1) {
            featureArray.push({
                type: "Feature",
                properties: {
                    cluster: false,
                    title: projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.title,
                    code: projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.code,
                    projectDetails: projectDetails,
                    displayAsEnriched: accessors_1.PublicProjectInfo.hasEnrichedData(projectDetails),
                    displayType: (projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.displayType) === core_1.PublicProjectDisplayType.TARGET
                        ? core_1.PublicProjectDisplayType.TARGET
                        : (0, PublicProjectInfoAccessor_1.hasEnrichedData)(projectDetails)
                            ? core_1.PublicProjectDisplayType.COMPLETED_ENRICHED
                            : core_1.PublicProjectDisplayType.COMPLETED,
                },
                geometry: displayGeometry,
            });
        }
    });
    return featureArray;
};
exports.getPublishedProjectsFeatureArrayFromProjectsDictionary = getPublishedProjectsFeatureArrayFromProjectsDictionary;
// export const getFeatureFromAddress = (addressDetails: IAddressDetails) => {
//   const featureArray: any[] = [];
//   featureArray.push({
//     type: "Feature",
//     properties: {
//       address: addressDetails?.full_address,
//     },
//     geometry: {
//       type: "Point",
//       coordinates: [addressDetails?.longitude, addressDetails?.latitude],
//     },
//   });
//   return featureArray;
// };
// export function executeQuery(
//   whereClause: any,
//   geometry: any,
//   offset: number,
//   signal?: AbortSignal
// ): Promise<any> | null {
//   return queryFeatures({
//     url: "https://services.gis.ca.gov/arcgis/rest/services/Boundaries/Parcels_Residential/MapServer/0/",
//     geometry: geometry, //  .toArray().flat(),
//     geometryType: "esriGeometryEnvelope",
//     inSR: "4326", // EPSG:4326 uses latitudes and longitudes
//     spatialRel: "esriSpatialRelIntersects",
//     resultOffset: offset ? offset * 1000 : 0,
//     where: whereClause,
//     f: "geojson",
//     returnGeometry: true,
//     outFields: [
//       "APN",
//       "SA_SITE_HOUSE_NBR",
//       "SA_SITE_STREET_NAME",
//       "SA_SITE_SUF",
//       "SA_ZONING",
//       "SA_SITE_CITY",
//       "SA_SITE_ZIP",
//       "SR_SITE_ADDR_RAW",
//     ],
//     signal: signal,
//   })
//     .then((response) => {
//       return response;
//     })
//     .catch((e) => {
//       return null;
//     });
// }
const randomizeCoordinatesWithinGivenRadius = (lat, lng, radiusInMeters) => {
    // Not totally accurate since the bounding box around the circle expands
    //  past the perimeter
    const center = [lng, lat];
    const options = { steps: 10, units: "meters" };
    const circle = turf.circle(center, radiusInMeters, options);
    const features = turf.randomPoint(1, {
        bbox: turf.bbox(circle),
    });
    return features.features[0].geometry;
};
exports.randomizeCoordinatesWithinGivenRadius = randomizeCoordinatesWithinGivenRadius;
//# sourceMappingURL=features.js.map